<div class="template-editor-container">
    <div class="dialog-header">
        <h2 mat-dialog-title>
            <mat-icon>{{readOnly ? 'visibility' : 'edit'}}</mat-icon>
            {{readOnly ? 'Visualizando Template: ' : 'Editor de Template: '}}
            {{templateTitle}}
        </h2>
    </div>

    <form [formGroup]="form">
        <mat-dialog-content>
            <mat-tab-group [selectedIndex]="currentTab === 'editor' ? 0 : 1"
                (selectedIndexChange)="setTab($event === 0 ? 'editor' : 'preview')"
                animationDuration="300ms"
                [class.read-only]="readOnly">

                <mat-tab label="Editor" [disabled]="readOnly">
                    <div class="editor-container">
                        <div class="variables-container">
                            <h3 class="section-title">
                                <mat-icon>build_circle</mat-icon>
                                Variáveis Disponíveis
                            </h3>

                            <p class="variables-description">
                                Clique em uma variável para inseri-la no
                                template.
                            </p>

                            <mat-accordion>
                                <mat-expansion-panel
                                    *ngFor="let category of getVariableCategories()">
                                    <mat-expansion-panel-header>
                                        <mat-panel-title>
                                            <mat-icon
                                                *ngIf="category === 'parceiro'">person</mat-icon>
                                            <mat-icon
                                                *ngIf="category === 'sistema'">computer</mat-icon>
                                            <mat-icon
                                                *ngIf="category === 'datas'">calendar_today</mat-icon>
                                            {{getCategoryTitle(category)}}
                                        </mat-panel-title>
                                    </mat-expansion-panel-header>

                                    <div class="variables-chips">
                                        <div class="chips-container">
                                            <button mat-stroked-button
                                                *ngFor="let variable of variables[category]"
                                                (click)="insertVariable(variable.name)"
                                                [matTooltip]="variable.description"
                                                matTooltipPosition="above"
                                                class="variable-chip">
                                                {{variable.name}}
                                            </button>
                                        </div>
                                    </div>
                                </mat-expansion-panel>
                            </mat-accordion>
                        </div>

                        <div class="editor-actions">
                            <button mat-stroked-button color="primary"
                                (click)="formatTemplate()"
                                [disabled]="readOnly">
                                <mat-icon>format_align_left</mat-icon>
                                Formatar HTML
                            </button>
                        </div>

                        <mat-form-field appearance="outline"
                            class="template-field">
                            <mat-label>Conteúdo do Template</mat-label>
                            <textarea
                                matInput
                                formControlName="template"
                                rows="20"
                                placeholder="Digite o template HTML aqui. Use as variáveis disponíveis acima para inserir dados dinâmicos."
                                [readonly]="readOnly">
                            </textarea>
                            <mat-hint *ngIf="!readOnly">Dica: Use variáveis para
                                dados dinâmicos e HTML para
                                formatação</mat-hint>
                        </mat-form-field>
                    </div>
                </mat-tab>

                <mat-tab label="Visualização">
                    <div class="preview-container">
                        <h3 class="section-title">
                            <mat-icon>preview</mat-icon>
                            Visualização do Template
                        </h3>

                        <div class="preview-content"
                            [innerHTML]="form.get('template')?.value || 'Nenhum conteúdo para visualizar'">
                        </div>
                    </div>
                </mat-tab>
            </mat-tab-group>
        </mat-dialog-content>

        <mat-dialog-actions align="end">
            <button mat-button (click)="onCancel()">
                {{readOnly ? 'Fechar' : 'Cancelar'}}
            </button>
            <button *ngIf="!readOnly" mat-raised-button color="primary"
                (click)="onSave()">
                <mat-icon>save</mat-icon>
                Salvar Template
            </button>
        </mat-dialog-actions>
    </form>
</div>